import React, { Component } from "react";
import PropTypes from 'prop-types'
import getPageProps from '@gcloud-npm/adabyron.page.get-props'
import MetaData from "@/bit/core/core.meta-data";
import Header from "@/bit/components/components.header";
import RouteHandler from '@/bit/core/core.route-handler'
import getAccountMenu from '@gcloud-npm/adabyron.header.get-account-menu'
import { connect } from 'react-redux'
import { actions as headerActions } from '@/bit/reducers/reducers.header-reducer'
import { actions as pageActions } from '@/reducers/page'
import { ENV_NAME } from "@gcloud-npm/utils.enums.environment";

class PageHandler extends Component {
  constructor(props){
    super(props)
    const { breadcrumbsProps, seoInfoProps, headerProps } = props;
    PageHandler.__singletonRef = this;
    this.state = {
      location: '',
      customDynamicPart: '',
      breadcrumbsProps,
      seoInfoProps,
      headerProps,
      account: null,
      breadcrumbsProps,
      loadingHeaderLocation: true,
    }
  }

  static updatePageProps(location, customDynamicPart) {
    PageHandler.__singletonRef.updatePageProps(location, customDynamicPart);
  }

  updatePageProps = async ({location, customDynamicPart}) => {
    try {
      const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
      const { context, onReceivePageProps, setPageInfo, pagesInfo, setAccountMenu } = this.props;
      setAccountMenu(null)
      // lo pongo null para que se vuelva a repedir y calcular el apartado actual
      let headerLocation = location;
      let tokkens = headerLocation.split('/');
      let dynamicPart = '';
      tokkens = tokkens.filter(token => !!token);
      const lastToken = tokkens[tokkens.length -1];
      const checkDynamicNumber = lastToken.match(/[0-9]/);
      if (checkDynamicNumber && checkDynamicNumber.length > 0) {
        tokkens.splice(tokkens.length -1, 1);
        dynamicPart = headerLocation;
        headerLocation = `/${tokkens.join('/')}`;
        dynamicPart = dynamicPart.replace(headerLocation, '');
      }else {
        headerLocation = `/${tokkens.join('/')}`;
      }
  
      headerLocation = headerLocation.replace('develop/', '')
      headerLocation = headerLocation.replace('qa/', '')


      let headerLocationReduxIndex = headerLocation;
      if (customDynamicPart){
        headerLocationReduxIndex = `${headerLocation}/${customDynamicPart}`
      } 
  
      /* ------------------------------------------------------- variables que necesito ------------------------------------------------------- */
      let headerProps = null;
      let breadcrumbsProps = null;
      let seoInfo = null;
      let headerInfo = null;
      let account = null;
      const promises = [];
      /* ------------------------------------------ tengo locationlisto para mirar si tengo en redux ------------------------------------------ */
      if(
        pagesInfo &&
        pagesInfo[headerLocationReduxIndex] &&
        pagesInfo[headerLocationReduxIndex].header
        ) {
        ({ 
          breadcrumbsProps,
          headerProps,
          account,
          seoInfo,
          customDynamicPart
         } =  pagesInfo[headerLocationReduxIndex].header);

      } else {
        /* ----------------------- Analizo enlaces de account ----------------------- */
        let preRenderEnv = '';
        if (currentEnv === ENV_NAME.LOCAL) {
          preRenderEnv = 'qa_ssr';
        }

        // const nextPages = ['/mi-cuenta', '/movistar-por-ti']
        let privateAreaFlag = true;
        if (window.location.pathname.indexOf('/mi-cuenta') > -1) {
          privateAreaFlag = false;
        }
        if (privateAreaFlag && window.location.pathname.indexOf('/movistar-por-ti') > -1) {
          privateAreaFlag = false;
        }

        promises.push(getAccountMenu({
          context,
          location: window.location.pathname,
          nAp: true,
          privateArea: privateAreaFlag,
          preRenderEnv,
        }));
        let seoLocation = `www.movistar.es/${headerLocation}`;
        seoLocation = seoLocation.replace(/\/\//g, '/');
        promises.push(
          getPageProps({
            context,
            seoLocation,
            build: false,
            headerLocation,
            preRenderEnv,
          })
        )
        // cuando hagamos una promise o dos 
        const [ accountRes, pagePropsRes ] = await Promise.all(promises);
        account = accountRes;
        seoInfo = pagePropsRes.seo;
        headerInfo = pagePropsRes.header;
        breadcrumbsProps = headerInfo.breadcrumbsProps
        headerProps = headerInfo.headerProps
      }
      
      /* ----------------------------------------------------------- guardo en redux ---------------------------------------------------------- */
      setPageInfo({
        location: headerLocationReduxIndex,
        info: {
          headerProps,
          account,
          breadcrumbsProps,
          seoInfo,
          customDynamicPart,
        }
      })

      if (customDynamicPart) {
        breadcrumbsProps.breadcrumbs.title = customDynamicPart
      }
    
      /* ----------------------------------------------------- reparto a cada uno lo suyo ----------------------------------------------------- */
      this.props.setHeaderProps({ account });
      setAccountMenu({
        newItems: account.accountMenuProps,
        closeSessionProps: account.closeSessionProps
      })
      onReceivePageProps({
        breadcrumbs: breadcrumbsProps.breadcrumbs.breadCrumbs,
        account: account.accountMenuProps,
        customDynamicPart
      })
      this.setState({
        location,
        account: account.accountMenuProps,
        headerProps,
        breadcrumbsProps,
        loadingHeaderLocation:false,
        seoInfoProps: seoInfo,
      })


    } catch (error) {
      console.log("updateHeader -> error: ", error);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { location, customDynamicPart } = this.state;
    const { location: nextLocation, customDynamicPart: nextCustomDynamicPart } = nextState;

    const changeLocation = nextLocation !== location
    const changeDynamicPart = customDynamicPart !== nextCustomDynamicPart

    if(changeLocation){
      RouteHandler.loadPage();
    }

    return changeLocation || changeDynamicPart;
  }

  render() {
    const {disableHeader} = this.props;
    const { seoInfoProps, extraBreadcrumbsProps, breadcrumbsProps, headerProps, loadingHeaderLocation } = this.state;


    return (
      <>
        {!disableHeader && (
          <>
            <MetaData seoInfo={{...seoInfoProps }} />
            <Header 
              {...headerProps}
              {...breadcrumbsProps}
              showCP={false}
              extraBreadcrumbsProps={extraBreadcrumbsProps}
              loadingHeaderLocation={loadingHeaderLocation}
              logoutBackToHome = {true}
              privateArea
            />
          </>
        )}
      </>
    );
  }
}

PageHandler.defaultProps = {
  disableHeader: false,
}

PageHandler.protoTypes= {
  disableHeader: PropTypes.bool,
}


const mapStateToProps = (state) => ({
  pagesInfo: state.page.pagesInfo,
});

const mapDispatchToProps = (dispatch) => ({
  setHeaderProps: (data) => dispatch(headerActions.setupHeaderProps(data)),
  setAccountMenu: (data) => dispatch(headerActions.setAccountMenu(data)),
  setPageInfo: data => dispatch(pageActions.setPageInfo(data))

});

export default connect(mapStateToProps, mapDispatchToProps)(PageHandler);
